import { axios } from '@/plugins/axios'

export default class EvaluacionDisciplinaAdministrativaApiRepository {
  async getById(idPersonal, idEvaluacion) {
    try {
      const { data } = await axios.get(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/disciplinaAdministrativa/${idEvaluacion}`
      )
      return data.data[0]
    } catch (error) {
      throw new Error(`Failed to retrieve disciplinaAdministrativa: ${error.message}`)
    }
  }

  async create(payload) {
    try {
      const { data } = await axios.post(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${payload.fk_idPersonalEvaluado}/disciplinaAdministrativa`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to create disciplinaAdministrativa: ${error.message}`)
    }
  }

  async update(evaluacion) {
    try {
      const { data } = await axios.put(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${evaluacion.fk_idPersonalEvaluado}/disciplinaAdministrativa/${evaluacion.id}`,
        evaluacion
      )

      return data
    } catch (error) {
      throw new Error(`Failed to update disciplinaAdministrativa: ${error.message}`)
    }
  }

  async updateStatus(idPersonal, idEvaluacion, payload) {
    try {
      const { data } = await axios.put(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/disciplinaAdministrativa/${idEvaluacion}`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to update status of disciplinaAdministrativa: ${error.message}`)
    }
  }
}
